module.exports = __webpack_public_path__ + "img/25_57.7d28445b.png";